/**
 * CalculationPanel — the CUSTOM Formula tab body: formula + weight bounds
 * beside the pinned live preview, with the formula-set library actions.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { TabsContent } from '@/components/ui/layout/Tabs';
import { FormulaSetActions } from '@/features/flow-optimizer-library/picker';
import { PreviewSplitLayout } from '@/features/flow-optimizer/components/preview/panel';
import CalculationEngineTab from '@/features/flow-optimizer/tabs/CalculationEngineTab';

import { SPLIT_PANEL_CLASS, type CustomTabPanelsProps } from './panel-props';

const CalculationPanel: FC<CustomTabPanelsProps> = ({ draft, onChange, splitActive, sidePanel }) => (
  <TabsContent value="calculation" className={SPLIT_PANEL_CLASS}>
    <PreviewSplitLayout active={splitActive} panel={sidePanel}>
      <CalculationEngineTab
        formula={draft.formula}
        minWeight={draft.minWeight}
        maxWeight={draft.maxWeight}
        onFormulaChange={(formula) => onChange({ ...draft, formula })}
        onBoundsChange={(minWeight, maxWeight) => onChange({ ...draft, minWeight, maxWeight })}
        libraryActions={
          <FormulaSetActions
            formula={draft.formula}
            packageId={draft.packageId}
            onChange={(formula) => onChange({ ...draft, formula })}
          />
        }
      />
    </PreviewSplitLayout>
  </TabsContent>
);

export default CalculationPanel;
